import { Box, Heading, Text } from '@chakra-ui/react';

import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export function CaseStudyHero({ heroImage, title }: { heroImage: SanityImageType; title: string }) {
  return (
    <Box
      alignContent='center'
      background='linear-gradient(180deg, rgba(6, 7, 35, 0.55) 0%, rgba(0, 0, 0, 0.00) 100%), #171A53;'
      display='flex'
      justifyContent='center'
      padding='64px 16px 64px 16px'
      position='relative'
    >
      <Box maxWidth='content-max-width-lg' position='relative' zIndex={2}>
        <Text align='center' color='white' marginBottom='24px'>
          Case Study
        </Text>

        <Heading as='h1' color='white' size='marketing-3xl' textAlign='center'>
          {title}
        </Heading>
      </Box>
      <SanityImage
        fill={true}
        image={heroImage}
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </Box>
  );
}
